<!-- Componente original -->
<router-outlet></router-outlet>

<!-- Spinner para carga -->
<ngx-spinner
  bdColor="rgba(255, 255, 255, 0.8)"
  size="medium"
  color="#E41E3F"
  type="ball-clip-rotate"
  [fullScreen]="true"
>
  <p class="text-white">Cargando...</p>
</ngx-spinner>

<!-- Modal de sesión expirada -->
<app-session-expired-modal></app-session-expired-modal>